<div
   class="modal-header p-0"
   style="justify-content: end; margin-top: -5px; margin-bottom: 5px">
   <button
      type="button"
      class="btn-close position-static"
      data-bs-dismiss="modal"
      aria-label="Close"
      style="padding-bottom: 4px"
      (click)="onClose()">
      <span aria-hidden="true">×</span>
   </button>
</div>
<div
   *ngIf="!!product()"
   class="modal-body p-0"
   style="padding-left: 20px !important; padding-right: 20px !important">
   <vetcor-pricing-new-code-admin
      *ngIf="!!product().newCodeRequestId"
      [readonly]="!isCaptain"
      [newCodeRequestId]="product().newCodeRequestId"
      (onClose)="onClose()" />
   <ng-container *ngIf="!product().newCodeRequestId">
      <div
         *ngIf="isCaptain"
         style="display: inline-block; text-align: left; width: 65%; margin-top: -20px; vertical-align: top">
         <div style="font-size: 12px; line-height: 17px">
            <strong>PIMS Code:</strong>
            {{ product().code }}
            <br />
            <strong>PIMS Category:</strong>
            {{ product().pimsCategory }}
            <br />
            <strong>VC Product Description:</strong>
            <!-- TODO {{ product().vcProductDescription }} -->
            <br />
            <strong>Modeled Price Reason:</strong>
            <!-- TODO {{ product().modelPricingReason }}-->
         </div>

         <div style="margin-top: 30px">
            <table>
               <tr>
                  <td style="vertical-align: top; width: 40%">
                     <table class="detailsTable">
                        <tr>
                           <td>L12M Revenue Contribution %</td>
                           <td>
                              {{
                                 product().metrics?.l12MRevenueContributionPct ? getFormattedPct(product().metrics?.l12MRevenueContributionPct) : "0"
                              }}
                           </td>
                        </tr>
                        <tr>
                           <td>L12M Distinct Customer</td>
                           <td>
                              {{ product().metrics?.l12MDistinctClient ? product().metrics?.l12MDistinctClient : "0" }}
                           </td>
                        </tr>
                        <tr>
                           <td>L12M Quantity</td>
                           <td>
                              {{ product().metrics?.l12MQty ? product().metrics?.l12MQty : "0" }}
                           </td>
                        </tr>
                        <tr>
                           <td>L12M Repeat Customer</td>
                           <td>
                              {{ product().metrics?.l12MRepeatCustomer ? product().metrics?.l12MRepeatCustomer : "0" }}
                           </td>
                        </tr>
                        <tr>
                           <td>L12M Revenue</td>
                           <td>
                              {{ product().l12MRevenue ? (product().l12MRevenue | currency : "USD" : "symbol" : "1.0-0") : "0" }}
                           </td>
                        </tr>
                        <tr>
                           <td>YoY Quantity %</td>
                           <td>
                              {{ getFormattedPct(product().metrics?.yoYQtyPct) }}
                           </td>
                        </tr>
                        <tr>
                           <td>YoY Customer %</td>
                           <td>
                              {{ getFormattedPct(product().metrics?.yoYCustomerPct) }}
                           </td>
                        </tr>
                        <tr>
                           <td>YoY Revenue %</td>
                           <td>
                              {{ getFormattedPct(product().metrics?.yoYRevPct) }}
                           </td>
                        </tr>
                        <tr>
                           <td>% of Total Customer Using Code</td>
                           <td>
                              {{ getFormattedPct(product().metrics?.totalCustomerCodePct) }}
                           </td>
                        </tr>
                        <tr>
                           <td>% of Wellness Patient Using Code</td>
                           <td>
                              {{ getFormattedPct(product().metrics?.wellnessPatientCodePct) }}
                           </td>
                        </tr>
                        <tr>
                           <td>Practice Revenue Percentile</td>
                           <td style="max-width: 110px">
                              {{
                                 product().metrics?.practiceRevPercentile
                                    ? getFormattedPct(product().metrics?.practiceRevPercentile)
                                    : "Calculation Error"
                              }}
                           </td>
                        </tr>
                        <tr>
                           <td>Practice Profitability</td>
                           <td>
                              {{ getFormattedPct(product().metrics?.practiceProfitability) }}
                           </td>
                        </tr>
                        <tr>
                           <td>Current Price</td>
                           <td>
                              {{ product().currentPrice | currency : "USD" : "symbol" : "1.2-2" }}
                           </td>
                        </tr>
                        <tr>
                           <td>Current Price Percentile</td>
                           <td style="max-width: 110px">
                              {{
                                 product().metrics?.currentPricePercentile === 0
                                    ? "Lower 25th Percentile"
                                    : product().metrics?.currentPricePercentile === 25
                                    ? "25th to 50th Percentile"
                                    : product().metrics?.currentPricePercentile === 50
                                    ? "50 to 75th Percentile"
                                    : "Upper 75th Percentile"
                              }}
                           </td>
                        </tr>
                        <tr>
                           <td>Current Index Price Value</td>
                           <td>
                              {{ product().metrics?.currentIndexPriceVal | currency : "USD" : "symbol" : "1.2-2" }}
                           </td>
                        </tr>
                        <tr
                           *ngIf="vcProduct()"
                           [ngClass]="{ staleData: isStaleDate(vcProduct()?.lastScrapeDate) }">
                           <td style="vertical-align: sub">
                              <label class="mainCompetitorInfo">
                                 <span
                                    class="staleExclamation"
                                    [pTooltip]="'This data is more than 3 days old'"
                                    tooltipStyleClass="pims-tooltip"
                                    *ngIf="isStaleDate(vcProduct()?.lastScrapeDate)">
                                    !
                                 </span>
                                 Current Competitor Price
                              </label>

                              <span *ngIf="vcProduct()?.lastScrapeDate">
                                 <br />
                                 <label class="competitorInfo">Last Scrape Date</label>
                                 <br />
                                 <label class="competitorInfo">Vetcove Online ID</label>
                              </span>
                           </td>
                           <td style="max-width: 110px; vertical-align: sub">
                              <span class="mainCompetitorInfo">
                                 {{
                                    vcProduct()?.competitorPrice
                                       ? (vcProduct()?.competitorPrice | currency : "USD" : "symbol" : "1.2-2")
                                       : "Comp Price Not Identified"
                                 }}
                              </span>

                              <span *ngIf="vcProduct()?.lastScrapeDate">
                                 <br />
                                 <span class="competitorInfo">
                                    {{ vcProduct()?.lastScrapeDate | date : "M/d/yy" }}
                                 </span>
                                 <br />
                                 <span class="competitorInfo">
                                    <a
                                       *ngIf="vcProduct()?.websiteLink"
                                       [href]="vcProduct()?.websiteLink"
                                       target="_blank">
                                       {{ vcProduct()?.websiteLink.split("item=")[1].split("&")[0] }}
                                    </a>
                                 </span>
                              </span>
                           </td>
                        </tr>
                     </table>
                  </td>

                  <td style="vertical-align: top; padding-left: 80px">
                     <table class="detailsTable">
                        <tr>
                           <td>Lowball Price Floor</td>
                           <td
                              *ngIf="!isPracticeChange"
                              style="max-width: 110px">
                              {{
                                 product().metrics?.lowballPriceFloor
                                    ? (product().metrics.lowballPriceFloor | currency : "USD" : "symbol" : "1.2-2")
                                    : "Calculation Error"
                              }}
                           </td>
                           <td
                              *ngIf="isPracticeChange"
                              style="max-width: 110px">
                              N/A
                           </td>
                        </tr>
                        <tr *ngIf="!isPracticeChange">
                           <td>Recommended Price</td>
                           <td>
                              {{ product().modelPrice | currency : "USD" : "symbol" : "1.2-2" }}
                           </td>
                        </tr>
                        <tr>
                           <td style="line-height: 16px">
                              Expected $ Impact
                              <br />
                              <span style="font-size: 12px; font-style: italic">{{ !isPracticeChange ? "recommended" : "current" }} price</span>
                           </td>
                           <td>
                              {{ product().revenueImpact | currency : "USD" : "symbol" : "1.2-2" }}
                           </td>
                        </tr>
                        <tr>
                           <td style="line-height: 16px">
                              Expected % Impact
                              <br />
                              <span style="font-size: 12px; font-style: italic">{{ !isPracticeChange ? "recommended" : "current" }} price</span>
                           </td>
                           <td style="line-height: 13px">
                              {{ getFormattedPct(product().revenueImpact / product().l12MRevenue) }}
                           </td>
                        </tr>
                        <tr>
                           <td>Requested Price</td>
                           <td>
                              {{ product().newPrice | currency : "USD" : "symbol" : "1.2-2" }}
                           </td>
                        </tr>
                        <tr>
                           <td>Requested Reason</td>
                           <td
                              class="truncate-multiline"
                              [pTooltip]="product().rationale"
                              tooltipStyleClass="pims-tooltip"
                              style="font-size: 12px; line-height: 15px; max-width: 190px; text-align: right; direction: ltr; float: right">
                              {{ product().rationale }}
                           </td>
                        </tr>
                        <tr>
                           <td style="line-height: 16px">
                              Expected $ Impact
                              <br />
                              <span style="font-size: 12px; font-style: italic">requested price</span>
                           </td>
                           <td>
                              <ng-container *ngIf="group() as group">
                                 <ng-container *ngIf="group.product || group as p">
                                    <span *ngIf="hasPriceImpact(group, false) && p.recordType != 'SF'">
                                       {{ getPriceImpact(group, false) | formatCurrency }}
                                    </span>
                                    <span *ngIf="p.newPrice > 0 && p.recordType == 'SF'">
                                       {{ (p.newPrice - p.currentPrice) * p.l12MTransactions | formatCurrency }}
                                    </span>
                                 </ng-container>
                              </ng-container>
                           </td>
                        </tr>
                        <tr>
                           <td style="line-height: 16px">
                              Expected % Impact
                              <br />
                              <span style="font-size: 12px; font-style: italic">requested price</span>
                           </td>
                           <td style="line-height: 13px">
                              <ng-container *ngIf="group() as group">
                                 <ng-container *ngIf="group.product || group as p">
                                    <span *ngIf="hasPriceImpact(group, false) && p.recordType != 'SF'">{{ getPriceImpactPct(group, false) }}%</span>
                                    <span *ngIf="p.newPrice > 0 && p.recordType == 'SF'">
                                       {{ getFormattedPct((p.newPrice - p.currentPrice) / p.currentPrice) }}
                                    </span>
                                 </ng-container>
                              </ng-container>
                           </td>
                        </tr>

                        <tr style="position: relative">
                           <td
                              class="detailsOverrideTable"
                              colspan="2"
                              style="padding: 30px 0px 0px 0px !important">
                              <table
                                 class="detailsTable"
                                 style="width: 100%">
                                 <tr>
                                    <td>Override Price</td>
                                    <td *ngIf="!product().isEditing">
                                       {{ product().opsPrice | currency : "USD" : "symbol" : "1.2-2" }}
                                    </td>
                                    <td
                                       *ngIf="product().isEditing"
                                       style="padding-left: 40px">
                                       <input
                                          [(ngModel)]="product().opsPrice"
                                          ngModelOptions="{standalone: true}"
                                          (click)="onInputClick($event)"
                                          [attr.data-id]="product().id"
                                          name="opsPrice-{{ product().id }}"
                                          type="number"
                                          inputmode="decimal"
                                          min="0"
                                          (keydown)="!['-', 'e'].includes($event.key) || ($event.preventDefault() && false)"
                                          class="form-control"
                                          style="
                                             text-align: right;
                                             height: 32px;
                                             font-size: 12px;
                                             padding-left: 4px;
                                             padding-right: 4px;
                                             width: 155px;
                                          " />
                                    </td>
                                 </tr>
                                 <tr>
                                    <td>Override Reason</td>
                                    <td
                                       *ngIf="!product().isEditing"
                                       class="truncate-multiline pricingDetailsTextareaHidden"
                                       [pTooltip]="product().finalComment"
                                       tooltipStyleClass="pims-tooltip">
                                       {{ product().finalComment }}
                                    </td>
                                    <td
                                       *ngIf="product().isEditing"
                                       style="padding-left: 40px; margin-top: 15px">
                                       <textarea
                                          [(ngModel)]="product().finalComment"
                                          ngModelOptions="{standalone: true}"
                                          [attr.data-id]="product().id"
                                          (click)="onInputClick($event)"
                                          [ngClass]="{
                                             invalid: !isValidRationale(product(), true)
                                          }"
                                          name="finalComment-{{ product().id }}"
                                          minlength="6"
                                          #rationaleInput
                                          class="form-control pricingDetailsTextarea"></textarea>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td style="line-height: 16px">
                                       Expected $ Impact
                                       <br />
                                       <span style="font-size: 12px; font-style: italic">override price</span>
                                    </td>
                                    <td>
                                       <ng-container *ngIf="group() as group">
                                          <ng-container *ngIf="group.product || group as p">
                                             <span *ngIf="hasPriceImpact(group, true) && p.recordType != 'SF'">
                                                {{ getPriceImpact(group, true) | formatCurrency }}
                                             </span>
                                             <span *ngIf="p.opsPrice > 0 && p.recordType == 'SF'">
                                                {{ (p.opsPrice - p.currentPrice) * p.l12MTransactions | formatCurrency }}
                                             </span>
                                          </ng-container>
                                       </ng-container>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td style="line-height: 16px">
                                       Expected % Impact
                                       <br />
                                       <span style="font-size: 12px; font-style: italic">override price</span>
                                    </td>
                                    <td>
                                       <ng-container *ngIf="group() as group">
                                          <ng-container *ngIf="group.product || group as p">
                                             <span *ngIf="hasPriceImpact(group, true) && p.recordType != 'SF'">
                                                {{ getPriceImpactPct(group, true) }}%
                                             </span>
                                             <span *ngIf="p.opsPrice > 0 && p.recordType == 'SF'">
                                                {{ getFormattedPct((p.opsPrice - p.currentPrice) / p.currentPrice) }}
                                             </span>
                                          </ng-container>
                                       </ng-container>
                                    </td>
                                 </tr>
                              </table>

                              <div
                                 *ngIf="product().isEditing && !isPracticeChange"
                                 class="customTooltipBox">
                                 <div class="customTooltipBoxArrow"></div>
                                 <div
                                    class="customTooltipBoxContent"
                                    [ngStyle]="{
                                       opacity: !product().isSaving ? '1' : '0.2',
                                       'pointer-events': !product().isSaving ? 'all' : 'none'
                                    }">
                                    <a
                                       *ngIf="product().isEditing"
                                       class="priceManagerIcon"
                                       href="javascript:void(0);"
                                       (click)="onPriceSaveOps(product())"
                                       style="margin-right: 15px; margin-top: 10px; margin-left: 5px"
                                       title="Save price"
                                       alt="Save price">
                                       <i
                                          class="fa fa-check"
                                          style="font-size: 16px"></i>
                                    </a>
                                    <a
                                       href="javascript:void(0);"
                                       *ngIf="product().isEditing"
                                       (click)="onPriceSaveRemoveOps(product())"
                                       style="margin-right: 8px; font-size: 15px; margin-top: 15px; margin-left: 5px"
                                       title="Reset / Undo"
                                       alt="Reset / Undo">
                                       <i class="fa fa-undo"></i>
                                    </a>
                                    <a
                                       href="javascript:void(0);"
                                       *ngIf="product().isEditing"
                                       (click)="onCancelClicked()"
                                       title="Cancel"
                                       alt="Cancel">
                                       <div class="tooltipBoxClose">
                                          <i class="fa fa-remove"></i>
                                       </div>
                                    </a>
                                 </div>
                              </div>
                           </td>
                        </tr>
                     </table>
                  </td>
               </tr>
            </table>
         </div>
      </div>

      <div
         *ngIf="isCaptain"
         style="display: inline-block; text-align: right; width: 35%; vertical-align: top">
         <div style="font-size: 19px; line-height: 23px">
            <strong>{{ product().recordName }}</strong>
            <br />
            <span style="color: #6c6c6c; font-size: 14px; font-weight: 600">{{ product().practiceName }}</span>
         </div>
         <div style="margin-top: 50px; font-weight: 600; font-size: 14px; padding-left: 30px">
            Approve/Reject Recommendation
            <div style="color: #8a8a8a; font-size: 13px; line-height: 19px; padding-top: 5px">
               {{ product().newPrice > 0 && !isPracticeChange ? getOverrideRec(product()) : "N/A" }}
            </div>
         </div>
         <div style="margin-top: 25px; font-weight: 600; font-size: 14px; padding-left: 30px">
            Approve/Reject Reason Recommendation
            <div style="color: #8a8a8a; font-size: 13px; line-height: 19px; padding-top: 5px">
               {{ product().newPrice > 0 && !isPracticeChange ? recOverrideReason : "N/A" }}
            </div>
         </div>

         <div
            style="margin-top: 50px; font-weight: 600; font-size: 14px; padding-left: 30px"
            *ngIf="!isPracticeChange || !product().approvalStatus"
            class="detailsApproveRejectButtons">
            <button
               class="v-button v-button-md v-green"
               style="width: 255px; text-align: left"
               [ngStyle]="{
                  opacity: product().newPrice > 0 ? '1' : '0.2',
                  'pointer-events': product().newPrice > 0 ? 'all' : 'none'
               }"
               (click)="onPriceApprove(product())">
               <i class="fa fa-check"></i>
               &nbsp;&nbsp;Approve Practice Req. Price
            </button>
            <div style="height: 13px"></div>
            <button
               id="adminRejectAllButton"
               class="v-button v-button-md v-red"
               style="width: 255px; text-align: left"
               data-bs-dismiss="modal"
               (click)="onPriceReject(product())"
               [ngStyle]="{
                  opacity: product().newPrice > 0 ? '1' : '0.2',
                  'pointer-events': product().newPrice > 0 ? 'all' : 'none'
               }">
               <i class="fa fa-close"></i>
               &nbsp;&nbsp;Reject Practice Req. Price
            </button>
            <div style="height: 13px"></div>
            <button
               *ngIf="!isPracticeChange"
               type="button"
               class="v-button v-button-md v-blue"
               style="width: 255px; text-align: left"
               (click)="toggleEdit(product())"
               [ngStyle]="{
                  'pointer-events': product().isEditing ? 'none' : 'visible',
                  opacity: product().isEditing ? '0.4' : '1'
               }">
               <i class="fa fa-edit"></i>
               &nbsp;&nbsp;Update Override Price
            </button>

            <button
               *ngIf="isPracticeChange && !product().zohoTicketId"
               class="v-button v-button-md v-white"
               style="width: 255px; text-align: left"
               (click)="onBeginDiscussionClick()"
               [ngStyle]="{
                  'pointer-events': product().isSaving || !product().finalComment?.trim() ? 'none' : 'visible',
                  opacity: product().isSaving || !product().finalComment?.trim() ? '0.4' : '1'
               }"
               style="width: 255px; text-align: left">
               <i class="fa fa-user-friends"></i>
               &nbsp;&nbsp;Begin Discussion
            </button>
            <button
               *ngIf="isPracticeChange && product().zohoTicketId"
               class="v-button v-button-md v-white"
               (click)="openTicket(product())"
               style="width: 255px; text-align: left">
               <i class="fa fa-user-tag"></i>
               &nbsp;&nbsp;Open Zoho Ticket
            </button>
            <div style="height: 13px"></div>
            <button
               *ngIf="isPracticeChange"
               class="v-button v-button-md v-white"
               style="width: 255px; text-align: left"
               (click)="onModifyPriceClick()"
               [ngStyle]="{
                  'pointer-events': !product().opsPrice || product().isSaving ? 'none' : 'visible',
                  opacity: !product().opsPrice || product().isSaving ? '0.4' : '1'
               }"
               style="width: 255px; text-align: left">
               <i class="fa fa-edit"></i>
               &nbsp;&nbsp;Modify Price & End Discussion
            </button>
         </div>
      </div>

      <div
         *ngIf="!isCaptain && isPracticeChange"
         style="display: inline-block; text-align: left; width: 65%; margin-top: -20px; vertical-align: top">
         <div style="font-size: 12px; line-height: 17px">
            <strong>PIMS Code:</strong>
            {{ product().code }}
            <br />
            <strong>PIMS Category:</strong>
            {{ product().pimsCategory }}
         </div>
      </div>

      <div
         *ngIf="!isCaptain && isPracticeChange"
         style="display: inline-block; text-align: right; width: 35%; vertical-align: top">
         <div style="font-size: 19px; line-height: 23px">
            <strong>{{ product().recordName }}</strong>
            <br />
            <span style="color: #6c6c6c; font-size: 14px; font-weight: 600">
               Current Price: {{ product().currentPrice | currency : "USD" : "symbol" : "1.2-2" }}
            </span>
         </div>
      </div>

      <a
         *ngIf="isCaptain"
         (click)="scrollDown()"
         href="javascript:void(0);">
         <div class="jumpDownDetails"></div>
      </a>

      <vc-price-history
         *ngIf="isPracticeChange && !!priceChangeData?.length"
         title="Price Change History"
         [priceChangeData]="priceChangeData"></vc-price-history>

      <div
         class="detailsHistoryTrends"
         id="historicalTrendData">
         <div
            class="modal-header align-items-center justify-content-between p-0"
            style="margin-bottom: 45px">
            <h5 class="modal-title">Historical Trend Data</h5>
            <select
               [(ngModel)]="selectedChartYear"
               (change)="onYearChange(product().pimsId, product().practiceSKey)"
               class="form-select"
               style="width: 120px; float: right">
               @for (year of chartYears; track year) {
               <option [value]="year">{{ year }}</option>
               }
            </select>
         </div>

         <div class="chart">
            <apx-chart
               style="display: block"
               [series]="pricingRowService.chartOptionsTwo().series"
               [chart]="pricingRowService.chartOptionsTwo().chart"
               [xaxis]="pricingRowService.chartOptionsTwo().xaxis"
               [yaxis]="pricingRowService.chartOptionsTwo().yaxis"
               [labels]="pricingRowService.chartOptionsTwo().labels"
               [stroke]="pricingRowService.chartOptionsTwo().stroke"
               [tooltip]="pricingRowService.chartOptionsTwo().tooltip"
               [dataLabels]="pricingRowService.chartOptionsTwo().dataLabels"></apx-chart>
         </div>
      </div>
   </ng-container>
</div>
